export const DEFAULT_AREA_UNIT = 'м²';
